import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Page from "components/Page";
import {
    CardHeader,
    Card,
    CardBody,
    CardText,
    Button,
    Table,
    Row,
    Col,
    Alert
} from "reactstrap";
import "../../styles/estilos.css";
import Pagination from "react-js-pagination";
import { Textbox, Select as Select1, Checkbox } from "react-inputs-validation";
import Select from 'react-select';
import { FetchGuardarDatosConducto, FetchGuardarFormaPago, FetchGuardarFormaPagoRenovaciones, FetchObtenerConductos } from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { FetchPost } from '../../redux/actions/api'
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { urlGetPlanesPagoRenovacion } from "../../modules/renovaciones/api/urls";
import { obtenerCatalogoPaises } from "../../api/catalogos/catalogoService";
import { ambienteAplicacion, urlConsultarCedula, urlConsultarListaNegra, urlFVinculacion } from "../../constants/urls";
import { setObtenerDatosDebitoAutomatico } from "../../redux/actions/aCotizacion";
import { ramos } from "../../utils/constants";
import { apiPost } from "../../api";
import { isValidCI, isValidNombreEC } from "../../utils/validaciones";
import { estaEnListaNegra, LimpiarListaNegra } from "../../redux/actions/ACarritoProductos";



class DebitoAutomatico extends React.Component {
    constructor(props) {
        super(props);
        const { datosListadoConductos } = this.props;

        this.state = {
            esMismaPersona: props.esMismaPersona,
            valSubmit: false,
            esTarjeta: false,
            validate: false,
            crearConducto: false,
            selectConducto: false,
            selectTipo: '',
            selectBanco: '',
            selectPlan: '',
            textCuenta: '',
            textFecha: '',
            textCodigo: '',
            datosConductoSel: '',
            codCoreTipo: '',
            nombreTipo: '',
            valCuotaCal: '0.00',
            hasTipoError: true,
            hasFechaError: true,
            //hasCodigoError: true,
            hasCuentaError: true,
            hasBancoError: true,
            hasPlanError: true,
            hasValorCuotaError: false,
            hasNumCuotaError: false,
            activePage: 1,
            datosListadoConductos,
            numCuotasF: '',
            valorCuotaMinimaF: '',
            numeroElementos: datosListadoConductos.listaConductos.length,
            loadingvalue: false,
            mostrarPlanesPago: false,
            esTitular: true,
            esTercero: false,
            nacionalidadPagador: null,
            direccionPagador: '',
            cedulaPagador: '',
            nombresPagador:"",
            bloquearNombre: false,
            fechaNacimientoPagador: null,
            hasNacionalidadError: true,
            hasDireccionError: true,
            hasCedulaError: true,
            hasNombresError: true,
            hasFechaNacimientoError: true,
            listaPaises: [],
            nuevosBancos: this.props.datosBancos && (this.props.datosBancos.bancosCuotas) ? this.transformarBancos(this.props.datosBancos.bancosCuotas) : [],
            mostrarMensajeListaNegra: false,
            mensajeListaNegra: '',
            correoTitular: '',
            hasCorreoTitularError: true

        };
        this.validateForm = this.validateForm.bind(this);
    }
    handlePageChange = (pageNumber) => {
        //console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
    }
    toggleValidating(validate) {
        this.setState({ validate });
    }

    async validateForm(e) {
        e.preventDefault();
        this.setState({ loadingvalue: true });
        this.toggleValidating(true);
        this.valSubmit();
        const {
            selectTipo,
            selectBanco,
            selectPlan,
            textCuenta,
            textFecha,
            codCoreTipo,
            nombreTipo,
            hasTipoError,
            hasBancoError,
            hasPlanError,
            hasFechaError,
            //hasCodigoError,
            hasCuentaError,
            esTarjeta,
            selectConducto
        } = this.state;

        let validaCampos = false;
        let valorCuotaMinima = 0;
        let numCuotas = 0;
        let valorCuota = this.state.valCuotaCal;
        let cuotaPlan = selectPlan.cuotas;
        let idConducto = '';

        if (selectConducto) {
            if (!hasPlanError) {
                validaCampos = true;
                numCuotas = this.state.datosConductoSel.numeroCuotasMaximo;
                valorCuotaMinima = this.state.datosConductoSel.valorCuotaMinima;
                idConducto = this.state.datosConductoSel.id;
            }
        } else {
            if (!hasTipoError && !hasBancoError && !hasPlanError && !hasCuentaError) {
                if (esTarjeta) {
                    if (!hasFechaError) {
                        validaCampos = true;
                        numCuotas = this.state.selectBanco.mesesT;
                        valorCuotaMinima = this.props.datosDebito.debitoAuomatico.valorCuotaMinimaTarjeta;
                    }
                } else {
                    validaCampos = true;
                    numCuotas = this.state.selectBanco.mesesC;
                    valorCuotaMinima = this.props.datosDebito.debitoAuomatico.valorCuotaMinimaCuenta;

                }
            }
        }
        //console.log(this.props);
        if (validaCampos) {

            this.valValorCuota(false);
            //console.log("Valido!");

            let esTitularvalidate = true;

            if (!this.state.esTitular) {


                const {
                    hasNacionalidadError,
                    hasDireccionError,
                    hasFechaNacimientoError,
                    nacionalidadPagador,
                    direccionPagador,
                    fechaNacimientoPagador,
                    cedulaPagador,
                    hasCedulaError,
                    nombresPagador,
                    hasNombresError,
                    correoTitular,
                    hasCorreoTitularError
                } = this.state;

                // Refuerza validación de edad con moment (aunque el handler ya lo hace)
                const edad = moment().diff(moment(fechaNacimientoPagador), 'years');
                const edadValida = edad >= 18;

                const hayErroresExtra =
                    hasNacionalidadError ||
                    hasCedulaError ||
                    hasNombresError ||
                    hasDireccionError ||
                    hasFechaNacimientoError ||
                    hasCorreoTitularError ||
                    !nacionalidadPagador ||
                    !direccionPagador ||
                    !fechaNacimientoPagador ||
                    !correoTitular ||
                    !edadValida;

                if (hayErroresExtra) {
                    esTitularvalidate = false
                } else {
                    esTitularvalidate = true

                }





            } else {
                esTitularvalidate = true
            }
            if (!selectConducto && esTitularvalidate) {




                 const {transaccion, mensaje} = await this.comprobarListaNegra(this.state.cedulaPagador)

                if (transaccion == false) {

                    this.setState({
                        mostrarMensajeListaNegra: true,
                        mensajeListaNegra: mensaje,
                        loadingvalue: false
                    })

                    return false

                }

             
                 


                let datosJSON = {
                    empresa: "AIGMETROPOLITANA",
                    plataforma: "WEB",
                    numeroCuentaOTarjeta: textCuenta,
                    codigoBanco: selectBanco.value,
                    tipoCuentaoTarjeta: selectTipo,
                    tipoCuentaoTarjetaCodigoCore: codCoreTipo,
                    tipoCuentaoTarjetaNombre: nombreTipo,
                    idCliente: this.props.dataFacturacion.datosFacturacion.datosPagador[0].id,//this.props.datosCarrito.productosCarrito.carDatosPagadorFacturacion[0].id,
                    anioVencimientoTarjeta: textFecha,
                    //numeroCuotasMaximo: numCuotas,
                    numeroCuotasMaximo: selectPlan.cuotas,
                    valorCuotaMinima: valorCuotaMinima,
                    esTitular: this.state.esTitular,
                    idCarrito: this.props.dataFacturacion.datosFacturacion.idCarrito
                }

                if (!this.state.esTitular) {
                    datosJSON = {
                        ...datosJSON,
                        nacionalidad: this.state.nacionalidadPagador,
                        direccion: this.state.direccionPagador,
                        fechaNacimiento: this.state.fechaNacimientoPagador,
                        cedulaTitular: this.state.cedulaPagador,
                        nombresTitular: this.state.nombresPagador,
                        correoTitular: this.state.correoTitular,
                    }
                }
                //console.log("CONDUCTOS ENVIARRRR DATOS ", JSON.stringify(datosJSON))


                if (this.state.esTercero) {



                    const datosAsesor = {

                        sucursalSeleccionada: this.props.datosSucursales
                            .sucursalSelecionadaAsesor,

                        ambiente: ambienteAplicacion,
                        emailAsesor: this.props.dataUsuario.correo
                            ? this.props.dataUsuario.correo
                            : "",
                        ramo: 'VH',
                        codigoRamo: ramos.VEHICULOS.codigo,
                        codigoProducto: 6
                    }



                    await this.props.checkInListaNegra(this.props.pagador.cliIdentificacion, datosAsesor)

                    let datosListaNegra = this.props.datosListaNegra

                    console.log('datosListaNegra', datosListaNegra)

                    if (datosListaNegra.inListaNegra === true) {

                        this.setState({
                            mostrarMensajeListaNegra: true,
                            mensajeListaNegra: datosListaNegra.inListaNegraMensaje,
                            loadingvalue: false
                        })

                        return false

                    }



                }


                await this.props.guardarConducto(datosJSON);
                if (!this.props.datosGuardarConducto.guardarConductoHasError) {
                    idConducto = this.props.datosGuardarConducto.datoConducto;
                    //console.log(idConducto);
                    //refrescar el listado de conductos
                    await this.props.listarConductos({
                        "empresa": "AIGMETROPOLITANA",
                        "plataforma": "WEB",
                        "idCliente": this.props.dataFacturacion.datosFacturacion.datosPagador ? this.props.dataFacturacion.datosFacturacion.datosPagador[0].id : null,//this.props.datosCarrito.productosCarrito.carDatosPagadorFacturacion[0].id
                        "idCarrito": this.props.dataFacturacion.datosFacturacion.idCarrito

                    })
                    this.setState({
                        crearConducto: false,
                    })
                }
            }

            if (idConducto) {

                const PagoJSON = {
                    empresa: "AIGMETROPOLITANA",
                    plataforma: "WEB",
                    idCarrito: this.props.dataFacturacion.datosFacturacion.idCarrito,//this.props.datosCarrito.productosCarrito.idCarrito,
                    formCodigo: "debito-automatico",
                    idConducto: idConducto,
                    idPlanPago: selectPlan.id
                }

                await this.props.guardarFormaPago(PagoJSON);
                if (!this.props.datosGuardarFormaPago.guardarFormaPagoHasError) {
                    //console.log('PAGO CORRECTO');
                    //window.location.reload(); 

                    /**** Agregar codigo para solicitar formulario de vinculacionde  libelula  */
                    let resp = await FetchPost({
                        url: urlFVinculacion + this.props.dataFacturacion.datosFacturacion.idCarrito,
                        param: ''
                    });
                    const { transaccion, pasarPantallaFormulario, urlFormulario } = resp;
                    if (transaccion) {

                        if (pasarPantallaFormulario) {
                            this.props.history.push({
                                pathname: "/formulario-vinculacion",
                                search: `?url=${urlFormulario}&id=${this.props.dataFacturacion.datosFacturacion.idCarrito}`,
                            });
                        } else {

                            this.props.history.push({
                                pathname: '/final-cotizacionbroker'
                            });
                        }
                    }
                    else {
                        /** COdigo para redireccionar correctamente */
                        this.props.history.push({
                            pathname: '/final-cotizacionbroker'
                        });
                    }
                }

            }


        } else {
            this.valNumCuota(false);
            this.valValorCuota(false);
            //console.log("No valido!");
        }
        //console.log(validaCampos);

        //console.log(this.state);
        this.setState({ loadingvalue: false });
    }

    /*async  onClickProcesoFinal(){
        let idConducto='';
        if(!this.state.selectConducto){
            const datosJSON = {
                empresa: "AIGMETROPOLITANA",
                plataforma: "WEB",
                numeroCuentaOTarjeta: this.state.textCuenta,
                codigoBanco: this.state.selectBanco.value,
                tipoCuentaoTarjeta: this.state.selectTipo,
                tipoCuentaoTarjetaCodigoCore: this.state.codCoreTipo,
                tipoCuentaoTarjetaNombre: this.state.nombreTipo,
                idCliente: this.props.dataUsuario.cliCodigoCore,
                anioVencimientoTarjeta: this.state.textFecha,
                numeroCuotasMaximo: this.state.numCuotasF,
                valorCuotaMinima: this.state.valorCuotaMinimaF
            }
            //console.log("ENVIARRRR DATOS ", JSON.stringify(datosJSON))
            await this.props.guardarConducto(datosJSON);
            if (!this.props.datosGuardarConducto.guardarConductoHasError) {
                idConducto = this.props.datosGuardarConducto.idConducto;
                //console.log(idConducto);
                //window.location.reload(); 
            }
        }
        const PagoJSON = {
            empresa: "AIGMETROPOLITANA",
            plataforma: "WEB",
            idCarrito: this.props.datosPago.datosPagar.referencia,
            formCodigo: "debito-automatico",
            idConducto: idConducto,
            idPlanPago: this.state.selectPlan.value
        }
        console.log(PagoJSON);
    
      }
    */
    valValorCuota = (bandera) => {
        this.setState({
            hasValorCuotaError: bandera
        });
    }
    valNumCuota = (bandera) => {
        this.setState({
            hasNumCuotaError: bandera
        });
    }
    onIngresarConducto = (e) => {
        e.preventDefault();
        this.setState({
            crearConducto: true,
        })
    }

    onSelectConducto = async (id, e) => {
        e.preventDefault();
        let dataConducto = undefined
        if (this.state.datosListadoConductos.listaConductos.length > 0 && this.state.datosListadoConductos.listaConductos !== undefined) {
            dataConducto = this.state.datosListadoConductos.listaConductos.find(conducto => conducto.id === id);
        }
        else {
            dataConducto = this.props.datosListadoConductos.listaConductos.find(conducto => conducto.id === id);
        }
        console.log('dcasdadsa', dataConducto);
        if (dataConducto) {
            //Cargar la informacion de conducto        
            await this.cargarPlanesPorBanco(dataConducto.bancoCodigo);

            this.setState({
                crearConducto: true,
                selectConducto: true,
                datosConductoSel: dataConducto,
                textCuenta: dataConducto.numeroCuenta,
                mostrarPlanesPago: true
            })
            if (dataConducto.tipoCodigo === '3') {
                this.setState({
                    esTarjeta: true
                })

            }
        }

    }
    onCancelarConducto = (e) => {
        e.preventDefault();
        this.setState({
            crearConducto: false,
            selectConducto: false,
            esTarjeta: false,
            selectBanco: '',
            selectTipo: '',
            selectPlan: '',
            textCuenta: '',
            valCuotaCal: '0.00',
            hasBancoError: true,
            hasPlanError: true,
            valSubmit: false
        })
    }

    onCancelarDebito = (e) => {
        e.preventDefault();
        const param = new URLSearchParams(this.props.location.search);
        let id = param.get('id');
        this.props.history.push({
            pathname: '/forma-pago',
            search: `?id=${id}`
        });
    }

    handleChangeBanco = async (selectBanco) => {
        this.setState({ selectBanco: selectBanco, mostrarPlanesPago: false });
        this.setState({ hasBancoError: false });

        //Setear en blnaco el plan
        this.setState({
            selectPlan: '',
            valCuotaCal: '0.00'
        });
        this.setState({ hasPlanError: true });

        await this.cargarPlanesPorBanco(selectBanco.value);
    }

    handleChangeNacionalidad = (selected) => {
        const hasError = !selected;
        this.setState({
            nacionalidadPagador: selected,
            hasNacionalidadError: hasError
        });
    };

    handleChangeDireccion = (direccionPagador) => {
        const regValido = /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9\s\-#.,°/]{5,100}$/;
        const hasError = !regValido.test(direccionPagador);
        this.setState({
            direccionPagador,
            hasDireccionError: hasError
        });
    };

    comprobarListaNegra = async (identificacion) => {
        let url = urlConsultarListaNegra + identificacion;

        const data = await apiPost(url, {})

        return data
    }

    handleChangeCedula = (cedulaPagador) => {
        const hasError = !isValidCI(cedulaPagador);

        if (!hasError) {
            if (cedulaPagador.length === 10) {
                this.onConsultarCedula(cedulaPagador);
            }
        } else {

            this.setState({
                nombresPagador: "",
                hasNombresError: true
            });

        }
        this.setState({
            cedulaPagador,
            hasCedulaError: hasError,
            mostrarMensajeListaNegra: false
        });
    };

    handleChangeNombres = (nombresPagador) => {
        const hasError = !isValidNombreEC(nombresPagador);
        this.setState({
            nombresPagador,
            hasNombresError: hasError
        });
    };

    handleChangeFechaNacimiento = (fechaNacimientoPagador) => {
        const fechaNacimiento = moment(fechaNacimientoPagador, 'YYYY-MM-DD');
        const hoy = moment();
        const edad = hoy.diff(fechaNacimiento, 'years');

        const hasError = !(fechaNacimiento.isValid() && edad >= 18);

        this.setState({
            fechaNacimientoPagador,
            hasFechaNacimientoError: hasError
        });
    };
    handleChangeCorreoTitular = (correoTitular) => {
        const regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const hasError = !regEmail.test(correoTitular);
        this.setState({
            correoTitular,
            hasCorreoTitularError: hasError
        });
    };



    cargarPlanesPorBanco = async (idbanco) => {

        let resp = await FetchPost({
            url: `${urlGetPlanesPagoRenovacion}&codBanco=${idbanco}`, param: {
                empresa: "AIGMETROPOLITANA",
                ramo: this.props.dataFacturacion.datosFacturacion.carDescripcionRamo,
                bancosId: idbanco,
                codBanco: idbanco,

            }
        })
        const { transaccion } = resp
        if (transaccion) {
            //Codigo cuando la transaccion es correcta          
            let planesPago = resp.planesPago;
            let arrayplanesPago = [];
            if (planesPago.length > 0)
                planesPago.forEach(elementP => {
                    const elementoP = {
                        value: elementP.planCodigoCore,
                        id: elementP._id.$oid,
                        //   label: elementP.nombre,
                        label: `${elementP.planNroCuotas} CUOTAS EXACTAMENTE IGUALES SF`,
                        cuotas: elementP.planNroCuotas
                    }
                    arrayplanesPago.push(elementoP)
                });
            //Obtener Planes Data debito actual          
            let DataDebitoActual = this.props.datosDebito.debitoAuomatico
            if (DataDebitoActual) {
                DataDebitoActual = { ...DataDebitoActual, planesPago: arrayplanesPago };
                await this.props.setDataDebitoPlanes(DataDebitoActual)
                this.setState({ mostrarPlanesPago: true });
            }
            else {
                alert('No se ha podido obtener información de los planes de pago.')
            }
        }
        else {
            alert('No se ha podido obtener información de los planes de pago.')
        }

    }



    valSubmit = () => {
        this.setState({ valSubmit: true });
    }




    handleChangePlanPago = (selectPlan) => {
        let valorTotal = this.props.dataFacturacion.datosFacturacion.carValoresTotales.primaTotal;//this.props.datosCarrito.productosCarrito.valorTotal.totalcarrito;
        let cuotaPlan = selectPlan.cuotas;
        let calculo = 0;

        if (cuotaPlan !== null && cuotaPlan !== "" && cuotaPlan !== undefined && cuotaPlan !== 0 &&
            valorTotal !== null && valorTotal !== "" && valorTotal !== undefined && valorTotal !== 0) {
            calculo = (Number(valorTotal) / Number(cuotaPlan)).toFixed(2);
        }
        this.setState({
            selectPlan: selectPlan,
            valCuotaCal: calculo
        });
        this.setState({ hasPlanError: false });
        //console.log(`Option selected plan:`, selectPlan);
    }

    obtenerPaises = async () => {
        const resp = await obtenerCatalogoPaises();
        if (resp && resp.transaccion && Array.isArray(resp.paises)) {
            const listaPaises = resp.paises.map(pais => ({
                value: pais.paiCodigoCore,
                label: pais.paiNombre
            }));
            this.setState({ listaPaises });
            return listaPaises;
        }
        return [];
    }

    componentDidMount() {
        this.obtenerPaises()

        console.log("Iniciar Forma de Pago", this.state.nuevosBancos);
        window.scrollTo(0, 0)
    }

    onConsultarCedula = async (identificacion) => {
        this.setState({ loadingvalue: true });
        let resp = await FetchPost({
            url: urlConsultarCedula + identificacion,
            param: {},
        });
        const { transaccion, nombre, fecha_nacimiento } = resp;
        if (transaccion) {
            this.setState({
                nombresPagador: nombre,
                bloquearNombre: true,
                hasNombresError:false
            });
            this.setState({ blockui: false });
        } else {
            this.setState({
                nombresPagador: "",
                bloquearNombre: false,
                hasNombresError:true
            });
        }

        this.setState({ loadingvalue: false });

    };


    transformarBancos(data) {
        return data.map(item => ({
            ...item,
            value: item.bcoCodigoCore.toString(),
            label: item.bcoDesc ? item.bcoDesc: item.nombre,
            mesesC: 12,
            mesesT: 12
        }));
    }





    render() {
        let { datosListadoConductos } = this.props;
        const { loadingvalue } = this.state;
        let { validate, esTarjeta, crearConducto, selectConducto, hasValorCuotaError, hasNumCuotaError, hasBancoError, hasPlanError, selectPlan, selectBanco, activePage, mostrarPlanesPago } = this.state;
        let numCuotaMax = 0;
        let valCuotaMin = 0;
        if (esTarjeta) {
            numCuotaMax = this.state.selectBanco.mesesC;
            valCuotaMin = this.props.datosDebito.debitoAuomatico.valorCuotaMinimaTarjeta;
        } else {
            numCuotaMax = this.state.selectBanco.mesesT;
            valCuotaMin = this.props.datosDebito.debitoAuomatico.valorCuotaMinimaCuenta;
        }
        //console.log(hasValorCuotaError,hasNumCuotaError,'asfasfas');
        //console.log(this.props.datosDebito.debitoAuomatico.bancos);    
        return (

            <LoadingScreen
                loading={this.props.datosGuardarConducto.guardarConductoIsLoading || datosListadoConductos.obtenerConductosIsLoading || this.props.datosGuardarFormaPago.guardarFormaPagoIsLoading || loadingvalue}
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text="Cargando..."
            >
                <Page>
                    <Row className="justify-content-md-center">
                        <Col lg={8} md={8} sm={8} xs={12}>
                            <Card >
                                <CardHeader><h2 style={{ color: "#001871", textAlign: "center" }}> DÉBITO AUTOMÁTICO </h2></CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <h3 style={{ color: "#001871" }}> Detalle de Pago</h3>
                                            <h5 style={{ textAlign: "left" }}> El Valor Total a Pagar es: <strong>$ {this.props.dataFacturacion.datosFacturacion.carValoresTotales.primaTotal}</strong>.</h5>
                                        </Col>
                                    </Row>
                                    <hr></hr>
                                    <Row>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <Button className="btn btn-detail-white" onClick={this.onCancelarDebito}>
                                                <i className="fa fa-arrow-circle-left" aria-hidden="true"></i>{" REGRESAR A FORMAS DE PAGO "}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {crearConducto === false &&
                        <Row className="justify-content-md-center">
                            <Col lg={8} md={8} sm={8} xs={12}>
                                <Card >
                                    <CardHeader><h3 style={{ color: "#001871", textAlign: "center" }}> Listado de Conductos </h3></CardHeader>
                                    <CardBody>
                                        <Row>
                                            <div className="div-align-rigth">
                                                <Button className="btn btn-purple" onClick={this.onIngresarConducto}>
                                                    <i className="fa fa-plus-circle" aria-hidden="true" />{" CREAR CONDUCTO "}
                                                </Button>
                                            </div>
                                        </Row>
                                        <br></br>
                                        {datosListadoConductos.listaConductos.length > 0 &&
                                            <div>
                                                <Row>
                                                    <Col lg={12} md={12} sm={12} xs={12} >
                                                        <Table responsive className="table-bordered" style={{ textAlign: "center" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>#</th>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>Banco Emisor</th>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>Número de cuenta/tarjeta</th>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>Tipo</th>
                                                                    <th style={{ border: "1px solid #dee2e6" }}>Pagar</th>
                                                                </tr>
                                                            </thead>
                                                            {datosListadoConductos.listaConductos.map((conducto, index) => {
                                                                const fin = activePage * 5
                                                                const inicio = fin - 5
                                                                return (
                                                                    <tbody>
                                                                        {index >= inicio && index < fin &&
                                                                            <tr>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>{index + 1}</td>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>{conducto.bancoNombre}</td>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>{conducto.numeroCuenta}</td>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>{conducto.tipoNombre}</td>
                                                                                <td style={{ border: "1px solid #dee2e6" }}>
                                                                                    <Button
                                                                                        className={"btn btn-primary"}
                                                                                        onClick={(e) => this.onSelectConducto(conducto.id, e)}
                                                                                        style={{ display: "block", margin: "auto" }}
                                                                                    ><i className="fa fa-chevron-circle-right" aria-hidden="true" />{" SELECCIONAR"}
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        }
                                                                    </tbody>
                                                                );
                                                            })}
                                                        </Table>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Pagination
                                                            activePage={this.state.activePage}
                                                            itemsCountPerPage={5}
                                                            totalItemsCount={this.state.numeroElementos}
                                                            pageRangeDisplayed={5}
                                                            onChange={this.handlePageChange}
                                                            linkClass={"paginaciontaga"}
                                                            activeLinkClass={"activepagination"}
                                                            innerClass={"pagination centrarpagination"}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        }
                                        {datosListadoConductos.listaConductos.length === 0 &&
                                            <CardText><h5 style={{ textAlign: "center" }}> NO SE HA ENCONTRADO CONDUCTOS REGISTRADOS.</h5></CardText>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    }
                    {crearConducto === true &&
                        <form onSubmit={this.validateForm}>
                            <Row className="justify-content-md-center">
                                <Col lg={8} md={8} sm={8} xs={12}>
                                    <Card className="flex-row">
                                        <CardBody>
                                            <Row>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <h4 style={{ fontWeight: 'bold' }}>Datos del Pago</h4>
                                                    <p />
                                                </Col>
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <div>(*) Campos Requeridos</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5>Banco (*)</h5>
                                                </Col>
                                                {!selectConducto ? (
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Select
                                                            value={selectBanco}
                                                            //components={makeAnimated()}
                                                            onChange={this.handleChangeBanco}
                                                            options={this.state.nuevosBancos}
                                                            isSearchable={true}
                                                            placeholder={"Seleccione una entidad financiera."}
                                                            isMulti={false}
                                                        />
                                                        {hasBancoError && this.state.valSubmit &&
                                                            <span style={{ color: "red", fontSize: "0.9rem" }}>Por favor seleccione la entidad financiera.</span>
                                                        }
                                                    </Col>
                                                ) : (
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Textbox
                                                            tabIndex="1"
                                                            type="text"
                                                            id="txtBanco"
                                                            name="txtBanco"
                                                            classNameInput={"input-type-label form-control"}
                                                            value={this.state.datosConductoSel.bancoNombre}
                                                        />
                                                    </Col>
                                                )}
                                            </Row>
                                            <Row>
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5>Tipo de cuenta (*)</h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    {!selectConducto ? (
                                                        <Select1
                                                            tabIndex="6" // Optional.[String or Number].Default: none.
                                                            id={"selectTipo"} // Optional.[String].Default: "". Input ID.
                                                            name={"selectTipo"} // Optional.[String].Default: "". Input name.
                                                            value={this.state.selectTipo} // Optional.[String].Default: "".
                                                            optionList={this.props.datosDebito.debitoAuomatico.tiposConductos} // Required.[Array of Object(s)].Default: [].
                                                            validate={validate}
                                                            onBlur={e => {
                                                                //console.log(e);
                                                            }}
                                                            validationCallback={res =>
                                                                this.setState({
                                                                    hasTipoError: res,
                                                                    validate: false
                                                                })
                                                            }
                                                            onChange={(id, e) => {
                                                                if (id === "3")
                                                                    esTarjeta = true;
                                                                else
                                                                    esTarjeta = false;
                                                                var dataTipo = this.props.datosDebito.debitoAuomatico.tiposConductos.find(tipo => tipo.id === id);
                                                                this.setState({
                                                                    esTarjeta,
                                                                    selectTipo: id,
                                                                    codCoreTipo: dataTipo.codigoCore,
                                                                    nombreTipo: dataTipo.name
                                                                })
                                                            }} // Optional.[Func].Default: () => {}. Will return the value.
                                                            customStyleOptionListContainer={{
                                                                maxHeight: "200px",
                                                                overflow: "auto",
                                                                fontSize: "14px"
                                                            }}
                                                            validationOption={{
                                                                name: "selectTipo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                                msgOnError: "Por favor seleccione el tipo de cuenta"
                                                            }}
                                                        />
                                                    ) : (
                                                        <Textbox
                                                            tabIndex="1"
                                                            type="text"
                                                            id="txtTipo"
                                                            name="txtTipo"
                                                            classNameInput={"input-type-label form-control"}
                                                            value={this.state.datosConductoSel.tipoNombre}
                                                        />
                                                    )}
                                                </Col>
                                            </Row>
                                            {mostrarPlanesPago &&

                                                <div>

                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>{!esTarjeta ? "Número de cuenta (*)" : "Número de tarjeta (*)"}</h5>
                                                            {/*<h5>Número de cuenta o tarjeta(*)</h5>*/}
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Textbox
                                                                tabIndex="1"
                                                                type="number"
                                                                id="txtCuentaTarjeta"
                                                                name="txtCuentaTarjeta"
                                                                placeholder="1234 56789 0123 4567"
                                                                classNameInput={
                                                                    !selectConducto
                                                                        ? "form-control"
                                                                        : "input-type-label form-control"
                                                                }
                                                                value={this.state.textCuenta}
                                                                ref={this.textInput}
                                                                maxLength={12}
                                                                validate={validate}
                                                                onBlur={e => {
                                                                    //console.log(e);
                                                                }}
                                                                onChange={(textCuenta) => this.setState({ textCuenta })}
                                                                validationCallback={res =>
                                                                    this.setState({
                                                                        hasCuentaError: res,
                                                                        validate: false
                                                                    })
                                                                }
                                                                validationOption={{
                                                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                                    reg: /^[0-9]{6,12}$/,
                                                                    msgOnError: "Por favor ingrese un número de cuenta"
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>Plan de pagos (*)</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>

                                                            <Select
                                                                value={selectPlan}
                                                                //components={makeAnimated()}
                                                                onChange={this.handleChangePlanPago}
                                                                options={this.props.datosDebito.debitoAuomatico.planesPago}
                                                                isSearchable={true}
                                                                placeholder={"Seleccione un plan de pago."}
                                                                isMulti={false}
                                                            />


                                                            {hasPlanError && this.state.valSubmit &&
                                                                <span style={{ color: "red", fontSize: "0.9rem" }}>Por favor seleccione el plan de pago.</span>
                                                            }
                                                        </Col>
                                                    </Row>



                                                </div>



                                            }


                                            {esTarjeta === true && selectConducto === false &&
                                                <div>
                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Row className="justify-content-md-center">
                                                                <Col lg={6} md={6} sm={6} xs={12}>
                                                                    <h6>Fecha de expiración (*)</h6>
                                                                    <Textbox
                                                                        tabIndex="1"
                                                                        type="text"
                                                                        id="txtFechaVencimiento"
                                                                        name="txtFechaVencimiento"
                                                                        placeholder="MM/YY"
                                                                        classNameInput={
                                                                            !selectConducto
                                                                                ? "form-control"
                                                                                : "input-type-label form-control"
                                                                        }
                                                                        value={this.state.textFecha}
                                                                        ref={this.textInput}
                                                                        maxLength={5}
                                                                        validate={validate}
                                                                        onBlur={e => {
                                                                            //console.log(e);
                                                                        }}
                                                                        onChange={(textFecha) => this.setState({ textFecha })}
                                                                        validationCallback={res =>
                                                                            this.setState({
                                                                                hasFechaError: res,
                                                                                validate: false
                                                                            })
                                                                        }
                                                                        validationOption={{
                                                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                                            reg: /^([0-1][0-9]|[1-9])(\/)([1-9][0-9])$/,
                                                                            msgOnError: "La fecha de expiración es de la forma MM/YY y debe estar vigente"
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col lg={6} md={6} sm={6} xs={12}>
                                                                    {/*<h6>Código de seguridad (*)</h6>
                                    <Textbox
                                        tabIndex="1"
                                        type="password"
                                        id="txtCodigoSeguridad"
                                        name="txtCodigoSeguridad"
                                        placeholder="CVV"
                                        classNameInput={"form-control"}
                                        value={this.state.textCodigo}
                                        ref={this.textInput}
                                        validate={validate}
                                        maxLength = {4}
                                        onBlur={e => {
                                            console.log(e);
                                        }}
                                        onChange={(textCodigo)=>this.setState({textCodigo})}
                                        validationCallback={res =>
                                            this.setState({
                                                hasCodigoError: res,
                                                validate: false
                                            })
                                        }
                                        validationOption={{
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            reg: /^\d{4}|^\d{3}$/,
                                            msgOnError: "Por favor ingrese el codigo de seguridad correctamente"
                                        }}
                                    />*/}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>}
                                            {/*    <Row>
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5>Valor cuota</h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Textbox
                                                        tabIndex="1"
                                                        type="text"
                                                        id="txtValorCuota"
                                                        name="txtValorCuota"
                                                        classNameInput={"input-type-label form-control"}
                                                        value={'$ ' + this.state.valCuotaCal}
                                                    />
                                                </Col>
                                            </Row> */}
                                            <Row className="justify-content-md-center">
                                                <Col lg={10} md={10} sm={10} xs={12}>
                                                    {hasNumCuotaError && this.state && (
                                                        <Alert color="warning">
                                                            <center>
                                                                <p>
                                                                    Para su entidad financiera solo se puede diferir hasta<strong> {numCuotaMax} </strong>meses.
                                                                </p>
                                                            </center>
                                                        </Alert>
                                                    )}
                                                    {hasValorCuotaError && (
                                                        <Alert color="warning">
                                                            <center>
                                                                <p>
                                                                    El valor de las cuotas no puede ser menor a <strong>$ {valCuotaMin} </strong>.
                                                                </p>
                                                            </center>
                                                        </Alert>
                                                    )}
                                                </Col>
                                            </Row>

                                            {!selectConducto &&

                                                <Row>
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5>¿El pagador es el titular de la cuenta?</h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Checkbox
                                                            id={"checkTitular"} // Optional.[String].Default: "".  Input ID.
                                                            name={"checkTitular"} // Optional.[String].Default: "". Input name
                                                            value={this.state.esTitular} // Required.[String].Default: "".
                                                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                            checked={this.state.esTitular} // Required.[Bool].Default: false.
                                                            classNameInputBox={'check-uber'}
                                                            customStyleInputBox={{
                                                                backgroundColor: this.state.esTitular ? '#001871' : '#FFFFFF',
                                                                width: 20,
                                                                height: 20,
                                                            }}
                                                            onChange={(esTitular, e) => {
                                                                this.setState({
                                                                    esTitular,
                                                                });


                                                                //console.log(e);
                                                            }} // Required.[Func].Default: () => {}. Will return the value.
                                                        />
                                                    </Col>
                                                </Row>

                                            }

                             {/*                {!this.state.esMismaPersona &&
                                                <Row>
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5>¿El pagador es un tercero distinto al contratante?</h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Checkbox
                                                            id={"checkPagador"} // Optional.[String].Default: "".  Input ID.
                                                            name={"checkPagador"} // Optional.[String].Default: "". Input name
                                                            value={this.state.esTercero} // Required.[String].Default: "".
                                                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                            checked={this.state.esTercero} // Required.[Bool].Default: false.
                                                            classNameInputBox={'check-uber'}
                                                            customStyleInputBox={{
                                                                backgroundColor: this.state.esTitular ? '#001871' : '#FFFFFF',
                                                                width: 20,
                                                                height: 20,
                                                            }}
                                                            onChange={(esTercero, e) => {
                                                                this.setState({
                                                                    esTercero,
                                                                });


                                                                //console.log(e);
                                                            }} // Required.[Func].Default: () => {}. Will return the value.
                                                        />
                                                    </Col>
                                                </Row>

                                            } */}


                                            {!this.state.esTitular && (
                                                <>

                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>Número de cédula (*)</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Textbox
                                                                type="text"
                                                                id="cedulaPagador"
                                                                name="cedulapagador"
                                                                value={this.state.cedulaPagador}
                                                                onChange={this.handleChangeCedula}
                                                                classNameInput="form-control"
                                                                validate={this.state.validate}
                                                                
                                                                
                                                                validationOption={{
                                                                    check: true,
                                                                    required: true,
                                                                    msgOnError: "Ingrese una cedula válida",
                                                                    customFunc: (res) => {

                                                                        let validarCedula =isValidCI(res) 

                                                                        if(!validarCedula){
                                                                            return "Ingrese una cedula válida"
                                                                        } 
                                                                        

                                                                        return true
                                                                    }
                                                                }}
                                                            />




                                                        </Col>
                                                    </Row>
                                                        <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>Nombres (*)</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Textbox
                                                                type="text"
                                                                id="nombresPagador"
                                                                name="nombresPagador"
                                                                disabled={this.state.bloquearNombre}
                                                                value={this.state.nombresPagador}
                                                                onChange={this.handleChangeNombres}
                                                                classNameInput="form-control"
                                                                validate={this.state.validate}
                                                               
                                                                validationOption={{
                                                                    check: true,
                                                                    required: true,
                                                                     msgOnError: "Ingrese un nombre válido",
                                                                     customFunc: (res) => {

                                                                        let validarNombre =isValidNombreEC(res) 

                                                                        if(!validarNombre){
                                                                            return "Ingrese un nombre válido"
                                                                        } 
                                                                        

                                                                        return true
                                                                    }
                                                                }}
                                                            />




                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>Nacionalidad (*)</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Select
                                                                value={this.state.nacionalidadPagador}
                                                                onChange={this.handleChangeNacionalidad}
                                                                options={this.state.listaPaises}
                                                                isSearchable={true}
                                                                placeholder="Seleccione un país"
                                                            />
                                                            {this.state.valSubmit && this.state.hasNacionalidadError && (
                                                                <span style={{ color: "red", fontSize: "0.9rem" }}>
                                                                    Por favor seleccione la nacionalidad.
                                                                </span>
                                                            )}

                                                            {this.state.valSubmit && !this.state.nacionalidadPagador && (
                                                                <span style={{ color: "red", fontSize: "0.9rem" }}>
                                                                    Por favor seleccione la nacionalidad.
                                                                </span>
                                                            )}
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>Dirección del domicilio (*)</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Textbox
                                                                type="text"
                                                                id="direccionPagador"
                                                                name="direccionPagador"
                                                                value={this.state.direccionPagador}
                                                                onChange={this.handleChangeDireccion}
                                                                classNameInput="form-control"
                                                                validate={this.state.validate}
                                                                validationOption={{
                                                                    check: true,
                                                                    required: true,
                                                                    reg: /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9\s\-#.,°/]{5,100}$/,
                                                                    msgOnError: "Ingrese una dirección válida (5-100 caracteres, solo letras, números, espacios o guiones medios)"
                                                                }}
                                                            />




                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>Fecha de nacimiento (*)</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <DatePicker
                                                                dateFormat="dd/MM/yyyy"
                                                                selected={this.state.fechaNacimientoPagador}
                                                                onChange={this.handleChangeFechaNacimiento}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                className="form-control"
                                                                placeholderText="Seleccione una fecha"
                                                            />
                                                            <br></br>
                                                            {this.state.valSubmit && this.state.hasFechaNacimientoError && (
                                                                <span style={{ color: "red", fontSize: "0.9rem" }}>
                                                                    El pagador debe tener al menos 18 años.
                                                                </span>
                                                            )}

                                                            {this.state.valSubmit && this.state.hasFechaNacimientoError && (
                                                                <span style={{ color: "red", fontSize: "0.9rem" }}>
                                                                    Por favor ingrese la fecha de nacimiento.
                                                                </span>
                                                            )}

                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5>Correo electrónico del titular (*)</h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Textbox
                                                                type="email"
                                                                id="correoTitular"
                                                                name="correoTitular"
                                                                value={this.state.correoTitular}
                                                                onChange={this.handleChangeCorreoTitular}
                                                                classNameInput="form-control"
                                                                validate={this.state.validate}
                                                                placeholder="ejemplo@dominio.com"
                                                                validationOption={{
                                                                    check: true,
                                                                    required: true,
                                                                    reg: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                                    msgOnError: "Ingrese un correo electrónico válido"
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}

                                            <Row>
                                                <Col lg={4} md={4} sm={4} xs={12}>

                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>

                                                    <Alert color="info">
                                                        <center>
                                                            <p>
                                                                El débito se realizará del 1 al 5 de cada mes.
                                                            </p>
                                                        </center>
                                                    </Alert>

                                                    {(this.state.selectBanco && this.props.datosDebito.debitoAuomatico.planesPago.length == 0) && <Alert color="warning">
                                                        <center>
                                                            <p>
                                                                No se han encontrado opciones de plan de pago para el banco seleccionado
                                                            </p>
                                                        </center>
                                                    </Alert>}

                                                    {this.state.mostrarMensajeListaNegra
                                                        ?
                                                        <div style={{ marginTop: '10px' }}>
                                                            <Alert color="danger">
                                                                <center><p>{this.state.mensajeListaNegra}</p></center>
                                                            </Alert>
                                                        </div>
                                                        :
                                                        null
                                                    }

                                                </Col>
                                            </Row>




                                            <Row className="justify-content-md-center">
                                                <div>
                                                    <Button
                                                        className={"btn btn-primary"}
                                                        onClick={this.validateForm}
                                                    ><i className="fa fa-chevron-circle-right" aria-hidden="true" />
                                                        {!selectConducto ? " GUARDAR" : " PAGAR"}
                                                    </Button>
                                                    &nbsp;&nbsp;
                                                    <Button
                                                        className={"btn btn-detail-white"}
                                                        type="submit"
                                                        onClick={this.onCancelarConducto}
                                                    ><i className="fa fa-ban" aria-hidden="true" /> CANCELAR
                                                    </Button>
                                                </div>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </form>
                    }
                </Page>


            </LoadingScreen>

        );
    }
}

const mapStateToProps = state => ({
    datosPago: state.datosPago,
    datosCarrito: state.dataProductoCarrito,
    datosBancos: state.dataRecompraPaquete,
    datosDebito: state.datosDebitoAutomatico,
    dataUsuario: state.datosUsuarios.dataUsuario,
    datosListadoConductos: state.datosListadoConductos,
    datosGuardarConducto: state.datosGuardarConducto,
    datosGuardarFormaPago: state.datosGuardarFormaPago,
    //Obtener datos de un servicio comun
    dataFacturacion: state.dataFacturacion,
    datosListaNegra: state.datosListaNegra,
    datosSucursales: state.datosSucursales,
});

const mapDispatchToProps = dispatch => {
    return {
        guardarConducto: datos => dispatch(FetchGuardarDatosConducto(datos)),
        guardarFormaPago: datos => dispatch(FetchGuardarFormaPagoRenovaciones(datos)),
        listarConductos: datos => dispatch(FetchObtenerConductos(datos)),
        setDataDebitoPlanes: (datos) => dispatch(setObtenerDatosDebitoAutomatico(datos)),
        checkInListaNegra: (identificacion, datos) => dispatch(estaEnListaNegra(identificacion, datos)),
        limpiarDatosListaNegra: () => dispatch(LimpiarListaNegra()),

    };
};
export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(DebitoAutomatico)
);
